import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const Fallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 2rem;
  text-align: center;
  font-family: "Quicksand", sans-serif;
`;

const Message = styled.p`
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const SubMessage = styled.p`
  font-size: 1rem;
  margin-bottom: 1.5rem;
`;

const TryAgainButton = styled.button`
  padding: 1rem 2rem;
  border: 0;
  border-radius: 16px;
  font-family: "Quicksand", sans-serif;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: white;
  background: #8747d4;
  cursor: pointer;

  &:hover {
    background: #9859e0;
  }
`;

function SomethingWentWrong() {
  const history = useHistory();

  return (
    <Fallback>
      <Message>Something went wrong.</Message>
      <SubMessage>Please try again later.</SubMessage>
      <TryAgainButton onClick={() => history.push("/LoginPage")}>
        Try again
      </TryAgainButton>
    </Fallback>
  );
}

export default SomethingWentWrong;
